import { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Slick.css";

const Slick = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const sliderRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const settings = {
    dots: false,
    centerMode: true,
    className: "center",
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    autoplay: true,
    focusOnSelect: true,
    speed: 400,
    autoplaySpeed: 2000,
    centerPadding: "20px",
    lazyLoad: "ondemand",
    pauseOnHover: false,
    afterChange: (current) => {
      setCurrentSlide(current);
    },
    responsive: [
      {
        breakpoint: 1850,
        settings: {
          slidesToShow: 3,
          centerPadding: "20px",
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          centerPadding: "40px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerPadding: "10px",
        },
      },
    ],
  };

  const projectData = [
    {
      id: 1,
      frontImage: require("../assets/image/PJ_JWA_2.png"),
      backImage: require("../assets/image/PJ_JWA_2.png"),
      year: "2021",
      logo: require("../assets/image/CL_UBR.png"),
      description:
        "14 Rides CSEI certificated consultant.  JWA and HTYD dragon commissioning. 3 Special effects safety related control system design and build.",
    },
    {
      id: 2,
      frontImage: require("../assets/image/PJ_KFP_1.png"),
      backImage: require("../assets/image/PJ_KFP_2.png"),
      year: "2021",
      logo: require("../assets/image/CL_UBR.png"),
      description:
        "Parkwide themed finsh. KFP showbox show set. CampJ project management. ",
    },
    {
      id: 3,
      frontImage: require("../assets/image/PJ_WW_1.png"),
      backImage: require("../assets/image/PJ_WW_2.png"),
      year: "2021",
      logo: require("../assets/image/CL_UBR.png"),
      description:
        "WW Show Action Equipment Installation Management and Commissioning. ",
    },
    {
      id: 4,
      frontImage: require("../assets/image/PJ_LEGO_1.png"),
      backImage: require("../assets/image/PJ_LEGO_1.png"),
      year: "2024",
      logo: require("../assets/image/CL_LEGO.png"),
      description:
        "Lego- Three E-ticket darkrides show system design development.  Parkwide AVLC design development. Three E-ticket darkrides OURA and safety related show elements design..",
    },
    {
      id: 5,
      frontImage: require("../assets/image/PJ_DD_1.png"),
      backImage: require("../assets/image/PJ_DD_2.png"),
      year: "2024",
      logo: require("../assets/image/CL_UBR.png"),
      description:
        "Entertaiment Production and Entertaiment Technical Support:  Spring Festival Theming Production.  Halloween two haunted house RSS system design and build.",
    },
  ];

  // Handle the hover behavior
  const handleMouseEnter = (e, index) => {
    if (e.currentTarget.closest(".slick-center") && index === currentSlide) {
      setHoveredIndex(index);
      sliderRef.current?.slickPause();
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    if (currentSlide === hoveredIndex) {
      setHoveredIndex(null);
      setIsHovered(false);
      if (sliderRef.current) {
        setTimeout(() => {
          sliderRef.current.slickNext();
        }, 1000);
        sliderRef.current.slickPlay();
      }
    }
  };

  return (
    <div className="slider-wrapper-container">
      <h1>
        <span style={{ fontSize: "bold", color: "#659f4c" }}>Projects</span> for
        our honored clients and customers
      </h1>
      <Slider {...settings} ref={sliderRef} className="slider-wrapper">
        {projectData.map((project, index) => {
          return (
            <div
              key={project.id}
              className={`card-container-wrapper`}
              onMouseEnter={(e) => handleMouseEnter(e, index)}
              onMouseLeave={handleMouseLeave}
            >
              <div
                className="front"
                style={{ backgroundImage: `url(${project.frontImage})` }}
              >
                <p className="card-year">YEAR {project.year}</p>
              </div>
              <div className="back">
                <img
                  src={project.logo}
                  alt="Client Logo"
                  className="client-logo"
                />
                <p className="description">{project.description}</p>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Slick;
